import React, { Component } from "react"
import { NamespacesConsumer as I18n } from "react-i18next"
import { NotificationManage } from "../../components/NotificationManage"
import validator from "validator"
import { connect } from "react-redux"
import { compose } from "redux"

//component
import { sizeofwindows } from "../Function/App.function"
import * as user_actions from "../../actions/action_user"

//material ui
import PropTypes from "prop-types"
import TextField from "@material-ui/core/TextField"
import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import FormControl from "@material-ui/core/FormControl"
import VpnKeyIcon from "@material-ui/icons/VpnKey"
import Typography from "@material-ui/core/Typography"
import withStyles from "@material-ui/core/styles/withStyles"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import CircularProgress from "@material-ui/core/CircularProgress"
import { ForgotPasswordStyle } from "../Style/ForgotPasswordStyle"

class ForgotPassword extends Component {
	constructor(props) {
		super(props)
		this.state = {
			email: "",
			erroremail: false,
			hideNav: false
		}
	}
	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this))
		this.resize()
	}
	resize() {
		this.setState({ hideNav: sizeofwindows("md") })
	}
	UNSAFE_componentWillReceiveProps() {
		this.setState({ email: "", erroremail: false })
	}
	handleChange = event => {
		if (event.target.id === "email") {
			this.setState({
				[event.target.id]: event.target.value
					.toLowerCase()
					.trim()
					.replace(/\s+/g, "")
			})
		} else {
			this.setState({
				[event.target.id]: event.target.value
			})
		}
		if (event.target.id === "email") {
			if (event.target.value.length === 0) {
				this.setState({ erroremail: false })
			} else {
				if (
					validator.isEmail(
						event.target.value
							.toLowerCase()
							.trim()
							.replace(/\s+/g, "")
					)
				) {
					this.setState({ erroremail: false })
				} else {
					this.setState({ erroremail: true })
				}
			}
		}
	}

	validateForm() {
		if (!validator.isEmail(this.state.email) || this.state.email.length === 0) {
			return false
		}
		return true
	}

	handleConfirmationSubmit = (event, t) => {
		event.preventDefault()
		this.props
			.forgot_password(this.state.email)
			.then(res => {
				NotificationManage(
					"info",
					`${t("NotificationManager.user.converify")}`,
					`${t("NotificationManager.status.info")}`
				)
				this.props.handleClickClose()
				this.props.handleClickOpen(event, "Repassword")
			})
			.catch(err => {
				NotificationManage(
					"error",
					`${t("NotificationManager.status.emessage")} ${err.message}`,
					`${t("NotificationManager.status.Error")}`
				)
			})
	}

	render() {
		const { classes, handleClickClose, Open, finish } = this.props
		const { erroremail, hideNav } = this.state
		return (
			<I18n>
				{t => {
					return (
						<Dialog
							open={Open}
							fullWidth={hideNav === false ? false : true}
							onClose={handleClickClose}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogContent className={classes.paper}>
								<Avatar className={classes.avatar}>
									<VpnKeyIcon />
								</Avatar>
								<Typography
									variant="h5"
									component="h3"
									style={{ fontSize: 18, fontFamily: "Roboto, sans-serif" }}
								>
									{t("login.loginForgotPassword1")}
								</Typography>
								<form
									className={
										hideNav === false ? classes.form : classes.formMobile
									}
								>
									<FormControl margin="normal" required fullWidth>
										<TextField
											error={erroremail}
											id="email"
											label={t("login.loginEmail")}
											placeholder={t("login.eg")}
											value={this.state.email}
											onChange={this.handleChange}
											autoFocus
										/>
									</FormControl>

									<div className={classes.root}>
										<div className={classes.wrapper}>
											<Button
												aria-label="handleConfirmationSubmit"
												type="submit"
												fullWidth
												variant="contained"
												color="primary"
												disabled={!this.validateForm() || finish}
												className={classes.submit}
												onClick={event =>
													this.handleConfirmationSubmit(event, t)
												}
											>
												{t("button.buttonSend")}
											</Button>
											{finish && (
												<CircularProgress
													size={24}
													className={classes.buttonProgress}
												/>
											)}
										</div>
									</div>
								</form>
							</DialogContent>
						</Dialog>
					)
				}}
			</I18n>
		)
	}
}

ForgotPassword.propTypes = {
	classes: PropTypes.object.isRequired
}
function mapStateToProps(reduxState) {
	return {
		finish: reduxState.UserReducer.finish
	}
}
const mapDispatchToProps = function(dispatch) {
	return {
		forgot_password: username =>
			dispatch(user_actions.forgot_password(username))
	}
}
export default compose(
	withStyles(ForgotPasswordStyle),
	connect(mapStateToProps, mapDispatchToProps)
)(ForgotPassword)
